module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EIBbw6/tc-custom/9781620108994.jpg?1737543900936",
      "alt": "This image is the cover for the book Scott Pilgrim Color Collection Vol. 2, Scott Pilgrim"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scott Pilgrim Color Collection Vol. 2, Scott Pilgrim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The New York Times bestselling series and basis for the movie Scott Pilgrim vs. The World  is now available in a new softcover format! Collects both Scott Pilgrim and the Infinite Sadness and Scott Pilgrim Gets It Together color edition story pages in one massive volume for your convenience. Don't say we never did anything for you! Scott Pilgrim is dating Ramona Flowers, but he's still fighting his way through her seven evil exes. And now, one of his own evil exes has shown up: Envy Adams, who's dating Ramona's third evil ex, Todd Ingram (actual famous bass player guy). And if that's not enough, Ramona's fourth ex is Roxy Richter (ninja, not famous). As the exes get more powerful, can Scott level up and defeat them?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bryan Lee O'Malley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bryan Lee O'Malley is a Canadian cartoonist. His award-winning Scott Pilgrim series (2004-2010) was a New York Times best seller and the basis for the 2010 Universal film Scott Pilgrim Vs the World. In 2023, he co-wrote and co-produced the Netflix animated series Scott Pilgrim Takes Off. His books, including Lost at Sea, Seconds, and Snotgirl, have been translated into over twenty languages. He lives in Los Angeles.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0